module.exports = new __parcel__URL__("soleil-nuage-1-pluie-3.8ee1c01c.svg").toString();